import { clientHasFeature, Features } from '../../../../shared/features'

/**
 * The Copilot is for Operators, also while they impersonate a Service Provider.
 * Impersonation keeps the Operator as loggedInUser, so the user type alone decides
 * (unlike Common.userIsOperator, which is false during impersonation).
 */
export function copilotAvailable({ loggedInUser, selectedClient }: { loggedInUser?: any, selectedClient?: any, isImpersonation?: boolean }): boolean {
	if (loggedInUser?.fields?.type?.de !== 'operator') return false
	if (!selectedClient) return false
	return clientHasFeature(selectedClient, Features.AI_COPILOT)
}
